import { Body, ConfirmationSvg, Icon, Spacer } from '@spritz-finance/ui'
import { BadgeContainer } from './BadgeContainer'

export const VerifiedBadge = ({ verified }: { verified: boolean }) => {
    return (
        <BadgeContainer $visible={verified}>
            <Icon size={24} icon={ConfirmationSvg} />
            <Spacer width={4} />
            <Body.SmBold size={10}>Verified</Body.SmBold>
        </BadgeContainer>
    )
}
